// Accent-insensitive search normalization (#2), shared by client and worker so
// the query and the indexed text are folded the same way. Strips diacritics via
// Unicode NFD decomposition (so "bůček" -> "bucek" and the query "bucek" matches),
// lowercases, and collapses surrounding whitespace.
export function normalizeForSearch(input: string): string {
  // U+0300–U+036F is the combining diacritical marks block left behind by NFD.
  return input.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}
